import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Four microphone heads",
  layout: {
    type: "customCase010105",
    options: {
      views: [
        {
          description: `In the situation using two pairs of microphones, the material being symmetrical, only one measurement is needed.<br /><br />
          Are needed:`,
          image: `${config.ASSETS_URL}/01/case-01/slide05-view01-image.svg`,
          list: [
            "Microphones sensitivities at 1 kHz obtained with a calibrated source",
            "Relative calibration between microphones 1 and 2, and between microphones 3 and 4",
            "The FRF of the four microphones (curves)",
            "Note that it is better to use an anechoic end",
            "Formulas to calculate the elements of the scattering matrix",
            "The curves of R and T",
            "Formulas allowing to calculate equivalent compressibility and density",
            "The curves of equivalent compressibility and density",
          ],
        },
        {
          description: `A measurement is made without the sample. Microphones 1 and microphone i = 2, 3 or 4<br />are inverted, from which the sensitivities relative to first microphone are deduced`,
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view02-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view02-image02.svg`,
          ],
          list: [
            "The anechoic termination",
            "The two pair of microphones on both sides of the junction",
            "The loudspeaker",
            "The distance between microphones in a pair is 2 cm",
          ],
        },
        {
          description: "The relative calibration with respect <br />to microphone 1 is finally obtained by:",
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view03-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view03-image02.svg`,
          ],
        },
        {
          description:
            "The measured transfer functions H1i and H’1i, with and without microphones inversion, respectively, are shown below in amplitude and in phase.",
          image: `${config.ASSETS_URL}/01/case-01/slide05-view04-image.svg`,
        },
        {
          description: "The relative calibrations are obtained from H1i and H’1i using:",
          image: `${config.ASSETS_URL}/01/case-01/slide05-view05-image.svg`,
          equationImage: `${config.ASSETS_URL}/01/case-01/slide05-view05-equation.svg`,
        },
        {
          pages: [
            {
              title: "1. Positioning of the sample on the holder",
              image: `${config.ASSETS_URL}/01/case-01/slide05-view06-image01.svg`,
            },
            {
              title: "2. Holder with the sample well positioned",
              image: `${config.ASSETS_URL}/01/case-01/slide05-view06-image02.svg`,
            },
            {
              title: "3. Positioning of the holder on the measurement setup",
              image: `${config.ASSETS_URL}/01/case-01/slide05-view06-image03.svg`,
            },
            {
              title: "4. Setup ready for measurement",
              image: `${config.ASSETS_URL}/01/case-01/slide05-view06-image04.svg`,
            },
          ],
        },
        {
          pages: [
            {
              image: `${config.ASSETS_URL}/01/case-01/slide05-view07-image01.svg`,
            },
            {
              image: `${config.ASSETS_URL}/01/case-01/slide05-view07-image02.svg`,
            },
          ],
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view08-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view08-image02.svg`,
          ],
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view09-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view09-image02.svg`,
          ],
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view10-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view10-image02.svg`,
          ],
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view11-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view11-image02.svg`,
          ],
        },
        {
          images: [
            `${config.ASSETS_URL}/01/case-01/slide05-view12-image01.svg`,
            `${config.ASSETS_URL}/01/case-01/slide05-view12-image02.svg`,
          ],
        },
      ],
    },
  },
};

export default principle;
